import { render, staticRenderFns } from "./SizeDescriptionPage.vue?vue&type=template&id=5a016cde&scoped=true&"
import script from "./SizeDescriptionPage.vue?vue&type=script&lang=js&"
export * from "./SizeDescriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./SizeDescriptionPage.vue?vue&type=style&index=0&id=5a016cde&lang=scss&scoped=true&"
import style1 from "./SizeDescriptionPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a016cde",
  null
  
)

export default component.exports